// extracted by mini-css-extract-plugin
export default {"bx":"manual_bx__LwvkC","row":"manual_row__XcDfY","footer":"manual_footer__T0laq"};